import React from 'react'
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import green from "@material-ui/core/colors/green";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {createStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => createStyles({
    loadingContainer: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        background: 'transparent',
        padding: 16,
        [theme.breakpoints.up(480)]: {
            width: 460
        },
        [theme.breakpoints.up(1024)]: {
            marginTop: 64
        },
    }
}));

const Loading = () => {
    const {
        loadingContainer
    } = useStyles();

    return(
        <Paper data-testid='loading-screen' elevation={0} className={loadingContainer} style={{ marginTop: '20vh', marginBottom: '20vh' }}>
            <CircularProgress
                style={{ color: green[500], marginTop: 16 }}
                thickness={4}
                size={60}/>
        </Paper>
    )
}

export default Loading